import React from "react";
import Flag from "react-world-flags";

const corridors = [
  { name: "Nigeria", code: "NGA", currency: "NGN" },
  { name: "Ghana", code: "GHA", currency: "GHS" },
  { name: "Kenya", code: "KEN", currency: "KES" },
  { name: "Senegal", code: "SEN", currency: "XOF" },
  { name: "Cameroon", code: "CMR", currency: "XAF" },
];

const SupportedCorridors = () => {
    return (
        <div className="supported-corridors-area ptb-100 bg-color-edf1ee">
            <div className="container">
                <div className="section-heading text-center">
                    <span className="sub-title">Global Reach</span>
                    <h2>Money Transfer to</h2>
                    <p>Send money instantly to these countries with the best exchange rates.</p>
                </div>

                <div className="row justify-content-center">
                    {corridors.map((country, index) => (
                        <div key={index} className="col-lg-2 col-md-4 col-sm-6 mb-4">
                            <div className="single-corridor-card text-center bg-white p-4 rounded-3 shadow-sm h-100 d-flex flex-column align-items-center justify-content-center hover-effect">
                                <div className="flag-wrapper mb-3" style={{ width: '60px', height: '40px', overflow: 'hidden', borderRadius: '4px' }}>
                                    <Flag code={country.code} style={{ width: '100%', height: '100%', objectFit: 'cover' }} />
                                </div>
                                <h5 className="mb-1">{country.name}</h5>
                                <span className="text-muted small d-block">{country.currency}</span>
                            </div>
                        </div>
                    ))}
                </div>
            </div>
             <style jsx>{`
                .hover-effect {
                    transition: transform 0.3s ease, box-shadow 0.3s ease;
                    cursor: default;
                }
                .hover-effect:hover {
                    transform: translateY(-5px);
                    box-shadow: 0 10px 20px rgba(0,0,0,0.1) !important;
                }
            `}</style>
        </div>
    );
};

export default SupportedCorridors;
